module.exports = __webpack_public_path__ + "img/logo.013c57f9.png";